import type { TimeObject } from './time-object'

export enum LOCK_DURATION_ID {
  NO_LOCK = 'noLock',
  ONE_MONTH = 'oneMonth',
  THREE_MONTHS = 'threeMonths',
  SIX_MONTHS = 'sixMonths',
  TWELVE_MONTHS = 'twelveMonths',
}

export enum TRANSACTION_TYPE {
    CLAIM_TOKENS = 'claimTokens',
    CLAIM_AND_STAKE = 'claimAndStake',
    STAKE = 'stake',
    UNSTAKE = 'unstake',
    RENEW = 'renew',
}

export interface HoldingTableRow {
	id: string
	timestamp: number
	token: string
	amount: string
	dailyPower: number
	power: string
	boost: number
	baseDailyPower: number
	remainingTime: TimeObject
	amountInFiat: string
}

export enum EHelpType {
	HOW_POWER_MILES_WORK = 'how-power-miles-work',
	WHAT_REWARDS_CAN_I_WIN = 'what-rewards-can-i-win',
	MY_LEVEL_INFO = 'my-level-info',
}
